import { ChangeDetectionStrategy, Component, inject, Inject, input, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef  } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { BtnCloseComponent } from '../button/btn-close/btn-close.component';


export enum ToastType { 
  Success = 'Success',
  Error = 'Error',
  Warning = 'Warning'
}

@Component({
  selector: 'lib-snackbar',
  imports: [CommonModule, BtnCloseComponent],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent{
  type = input<string | undefined>();
  title = input<string | undefined>();
  message = input<string | undefined>();
  duration = input<string | undefined>();

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBarRef: MatSnackBarRef<SnackbarComponent>
  ) {}

  closeSnackbar() {
    this.snackBarRef.dismiss();
  }

  getBorderColor(toastType: ToastType): string {
    switch (toastType) {
      case ToastType.Success:
        return '#13BE00';
      case ToastType.Error:
        return '#A90000';
      case ToastType.Warning:
        return '#FDC602';
      default:
        return '#007bff';
    }
  }

  getBackgroundColor(toastType: ToastType): string {
    switch (toastType) {
      case ToastType.Success:
        return '#e6f4ea';
      case ToastType.Error:
        return '#fdecea';
      case ToastType.Warning:
        return '#fff8e1';
      default:
        return 'white';
    }
  }
}
